module.exports = __webpack_public_path__ + "static/java-f4edae33f980c312ee02291f2274e811.png";